import { useMemo, useRef } from 'react';

// This mimicks a constructor
function useOnce<T>(callback: () => T): T {
  const ref = useRef<() => T>(callback);
  return useMemo(() => ref.current(), [ref]);
}

export default useOnce;
